import { faBadgeCheck } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";
import React from "react";

import { blogsProfileUrl } from "@/mk2/apps/blogs/urls";
import { faqVerifiedReviewUrl } from "@/mk2/apps/faq/urls";
import { getWikiArticleUrl } from "@/mk2/apps/wiki/urls";
import { AvatarImg } from "@/mk2/components/AvatarImg";
import { Dot } from "@/mk2/components/Dot";
import { Link } from "@/mk2/components/Link";
import { timeAt } from "@/mk2/helpers/timeformat";
import { url } from "@/mk2/helpers/urls";
import { ExperienceEntity, ExperienceVerificationStatus } from "@/mk2/schemas";
import {
    REVIEW_VERIFIED,
    WIKI_EXP_DRAFT_VERIFIED_BY_PHONE_CALL,
    WIKI_EXP_GUEST_LABEL,
} from "@/mk/autogenerated/translation";

import styles from "./ExperienceHeader.mscss";

interface OwnProps {
    className?: string;
    experience: ExperienceEntity;
    showLinkToArticle?: boolean;
}

type Props = OwnProps;

export default class ExperienceHeader extends React.Component<Props> {
    public render() {
        const { className, experience, showLinkToArticle } = this.props;
        // Guest (unregistered) author: generic avatar, nickname with "(hosť)"
        // suffix, no profile link
        const isGuest = Boolean(experience.authorNickname);

        return (
            <div className={cx(styles.ExperienceHeader, className)}>
                <AvatarImg
                    size={18}
                    user={experience.authorUser}
                    href={
                        isGuest
                            ? undefined
                            : url(blogsProfileUrl, { username: experience.authorUser.username })
                    }
                />

                {isGuest ? (
                    <span className={styles.ExperienceHeader__author}>
                        {experience.authorNickname} ({WIKI_EXP_GUEST_LABEL})
                    </span>
                ) : (
                    <Link
                        className={styles.ExperienceHeader__author}
                        to={url(blogsProfileUrl, { username: experience.authorUser.username })}
                    >
                        {experience.authorUser.username}
                    </Link>
                )}

                <Dot spaces={1} className={styles.ExperienceHeader__dot} />

                <span key="created">{timeAt(experience.created)}</span>

                {experience.verificationStatus === ExperienceVerificationStatus.VERIFIED && (
                    <span>
                        <Link
                            to={faqVerifiedReviewUrl}
                            className={styles.ExperienceHeader__verified}
                        >
                            <FontAwesomeIcon icon={faBadgeCheck} /> {REVIEW_VERIFIED}
                        </Link>
                    </span>
                )}
                {experience.verifiedByAdmin && (
                    <span className={styles.ExperienceHeader__verifiedByPhone}>
                        <FontAwesomeIcon icon={faBadgeCheck} />{" "}
                        {WIKI_EXP_DRAFT_VERIFIED_BY_PHONE_CALL}
                    </span>
                )}
                {showLinkToArticle ? (
                    <>
                        <Dot spaces={1} className={styles.ExperienceHeader__dot} />

                        <Link
                            className={styles.ExperienceHeader__article}
                            to={getWikiArticleUrl(
                                experience.article.category.categoryArticleSlug,
                                experience.article.slug,
                            )}
                        >
                            {experience.article.title}
                        </Link>
                    </>
                ) : null}
            </div>
        );
    }
}
